import React from 'react';
import classnames from 'classnames';
import './faturamento.styles.css';
import MultiplosExamesContainer from '../../../../laudo/etapas/material/tabs/multiplosExames/multiplos-exames.container';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
  Badge,
} from 'reactstrap';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

export const ModalFaturamentoPage = (props) => {
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
  return(
  <div className='mv-container-faturamento'>
    <Modal
      size='sm'
      isOpen={props.alertaPendentes}
      toggle={() => props.closeModal(false)}
    >
      <ModalHeader toggle={() => props.closeModal(false)}>
      <IntlMessage id = "dashboards.examDetails.invoicing"/>
      </ModalHeader>
      <ModalBody><IntlMessage id = "dashboards.examDetails.changeswillbelost"/></ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={() => props.closeModal(false)}>
        <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button color='primary' onClick={() => props.closeModal(true)}>
          <IntlMessage id = "dashboards.examDetails.confirm"/>
        </Button>
      </ModalFooter>
    </Modal>
    <Modal
      size='sm'
      isOpen={props.alertaTodoFaturado}
      toggle={() => props.closeModal(false)}
    >
      <ModalHeader toggle={() => props.closeModal(false)}>
      <IntlMessage id = "dashboards.examDetails.invoicing"/>
      </ModalHeader>
      <ModalBody><IntlMessage id = "dashboards.examDetails.unbilledItems"/></ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={() => props.closeModal(false)}>
        <IntlMessage id = "dashboards.examDetails.no"/>
        </Button>
        <Button
          color='primary'
          onClick={() => props.closeAlertaItemNaoFaturado()}
        >
          <IntlMessage id = "dashboards.examDetails.yes"/>
        </Button>
      </ModalFooter>
    </Modal>
    <Modal size='lg' isOpen={props.open} toggle={props.checkCloseModal}>
      <ModalHeader toggle={props.checkCloseModal}>
        <IntlMessage id = "dashboards.examDetails.invoicing"/>
      </ModalHeader>
      <ModalBody>
        <div>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: props.activeTab === '1' })}
                onClick={() => {
                  props.toggle('1');
                }}
              >
                <IntlMessage id = "dashboards.examDetails.billExams"/>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: props.activeTab === '2' })}
                onClick={() => {
                  props.toggle('2');
                }}
              >
                <IntlMessage id = "dashboards.examDetails.multipleExams"/>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={props.activeTab}>
            <TabPane style={{ padding: '8px' }} tabId='1'>
              <Row>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id = "dashboards.examDetails.examStage"/></Label>
                    <SelectComponent
                      options={props.etapas}
                      placeholder={translate("dashboards.examDetails.selectStage")}
                      onChange={(e) => props.etapasOnChange(e)}
                      disabled={
                        props.etapas.length === 0 || props.bloquearConfig
                      }
                      value={props.etapaSelecionada}
                    />
                    {props.etapas.length === 0 && !props.bloquearConfig && (
                      <Label className='alerta-sem-etapas'>
                        <IntlMessage id = "dashboards.examDetails.applicablesteps"/>
                      </Label>
                    )}
                    {props.bloquearConfig && (
                      <Label className='alerta-sem-etapas'>
                        <IntlMessage id = "dashboards.examDetails.manualDisabled"/>
                      </Label>
                    )}
                  </FormGroup>
                </Col>
                <Col sm='auto'>
                  <FormGroup>
                    <Label><IntlMessage id = "dashboards.examDetails.quantity"/></Label>
                    <Input
                      type='number'
                      defaultValue={'1'}
                      value={props.quantidadeASerFaturada}
                      disabled={
                        props.etapas.length === 0 || props.bloquearConfig
                      }
                      onChange={(e) =>
                        props.quantidadeASerFaturadaOnChange(
                          e.currentTarget.value
                        )
                      }
                      min='1'
                      max='10'
                    />
                  </FormGroup>
                </Col>
                <Col sm='auto'>
                  <Button
                    style={{
                      fontSize: '12px',
                      marginTop: '27px',
                      height: '38px',
                    }}
                    color='primary'
                    onClick={(e) => props.faturar(e)}
                    disabled={
                      props.etapas.length === 0 ||
                      !props.etapaSelecionada ||
                      Number(props.quantidadeASerFaturada) < 1 ||
                      !props.medicoEtapa ||
                      props.bloquearConfig
                    }
                  >
                    <IntlMessage id = "dashboards.examDetails.invoice"/>
                  </Button>
                </Col>
              </Row>
              <Row>
                {props.etapaSelecionada && (
                  <Col>
                    <Label><IntlMessage id = "dashboards.examDetails.stageDoctor"/></Label>
                    <SelectComponent
                      options={props.medicos}
                      placeholder={translate("dashboards.examDetails.selectDoctorStage")}
                      onChange={(e) => props.medicoOnChange(e)}
                      value={props.medicoEtapa}
                      disabled={props.fatMedicoPadrao}
                    />
                  </Col>
                )}
              </Row>
              <br />
              {props.faturamentos.map((item, i) => {
                return (
                  <Row key={i}>
                    <Col>
                      <Card>
                        <CardBody>
                          <CardTitle>
                            <Row>
                              <div className='labelMedico'>
                                {item.medico !== null
                                  ? item.medico
                                  : <IntlMessage id = "dashboards.examDetail.doctorUndefined"/>}
                              </div>
                              <div style={{ width: '10%' }}>
                                {item.alterado && !item.novo && (
                                  <span className='badgeAlterado'>
                                    <IntlMessage id = "dashboards.examDetails.changed"/>
                                  </span>
                                )}
                                {item.novo && !item.alterado && (
                                  <span className='badgeNovo'><IntlMessage id = "dashboards.examDetails.new"/></span>
                                )}
                              </div>
                            </Row>
                          </CardTitle>
                          <Row>
                            <Col sm='auto'>
                              <Badge color='success'>{item.etapa}</Badge>
                            </Col>
                            <Col sm='auto'>
                              <strong>{item.exame}</strong>
                            </Col>
                            <Col sm='auto'>
                              <i><IntlMessage id = "dashboards.examDetails.quantity"/></i>{' '}
                              <strong>{item.qtdFaturado}</strong>
                            </Col>
                            {item.faturado && (
                              <Badge color='primary'><IntlMessage id = "dashboards.examDetail.billed"/></Badge>
                            )}
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                );
              })}
            </TabPane>
            <TabPane style={{ padding: '8px' }} tabId='2'>
              <MultiplosExamesContainer />
            </TabPane>
          </TabContent>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={props.checkCloseModal}>
        <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>
        <Button color='primary' onClick={props.confirmar}>
        <IntlMessage id = "dashboards.examDetails.confirm"/>
        </Button>
      </ModalFooter>
    </Modal>
  </div>
);
}



// WEBPACK FOOTER //
// ./src/pages/main/listagem/modais/faturamento/modal.faturamento.page.js